/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Empty_HintInputs */

const cs_audit_empty_hint = /** @type {(inputs: Audit_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokud čekáte záznamy a nic nevidíte, obnovte stránku nebo zkontrolujte oprávnění správce organizace.`)
};

const en_audit_empty_hint = /** @type {(inputs: Audit_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you expect rows and see none, refresh or confirm organization-admin access.`)
};

/**
* | output |
* | --- |
* | "If you expect rows and see none, refresh or confirm organization-admin access." |
*
* @param {Audit_Empty_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_empty_hint = /** @type {((inputs?: Audit_Empty_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Empty_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_empty_hint(inputs)
	return cs_audit_empty_hint(inputs)
});